import { useState } from 'react';
import { Row, Col, Card, CardBody, CardHeader, Button, Spinner, Badge, Collapse } from 'reactstrap';
import KMLUpload from '../ItemsView/KMLUpload';
import MapImport from '../Outline/MapImport';
import OutlineItems from '../Outline/OutlineItems';
import { FaMapMarkerAlt, FaChevronUp, FaChevronDown } from 'react-icons/fa';
import uuid from 'react-uuid';

const OutlineMapView = ({ outline, mapDetails, saving, isLargeEnterprise,handleClearSelection, handleItemClick, handlelargeEnterpriseChange, handleZoomChange, handleFarmDetailSave,
    importShapeFilesClick,findMyFarm }) => {
    const roleName = localStorage.getItem("roleName");
    const saveRightsForNonItemFieldsAndTables = localStorage.getItem("saveRightsForNonItemFieldsAndTables");
    const [isOpen, setIsOpen] = useState(true);
    const [isIconUp, setIsIconUp] = useState(true);

    const toggle = () => {
        setIsOpen(!isOpen)
        setIsIconUp(!isIconUp)
    };

    const FarmCenter = outline.outlineList.filter(type => type.mapType == 'marker');
    let isFarmCenter = false;
    const Location = { longitude: '', latitude: '' };
    if (FarmCenter != null && FarmCenter.length > 0) {
        isFarmCenter = true;
        Location.longitude = FarmCenter[0].coordinates.split(',')[1];
        Location.latitude = FarmCenter[0].coordinates.split(',')[0];
    }

    return (
        <Row>
            <Col>
                <Card className="cardNonLeftRadius">
                    <CardHeader className="item-header item_click card-header1" onClick={toggle}>
                        <Row>
                            <Col sm="11">
                                <h5 className="color-dark-teal">My Farm</h5>
                            </Col>
                            <Col sm="1" style={{ marginLeft: "auto", marginRight: "5px" }} className="toggleoutline">
                                {isIconUp ? <FaChevronUp /> : <FaChevronDown />}
                            </Col>
                        </Row>
                    </CardHeader>
                    <Collapse isOpen={isOpen}>
                        <CardBody>
                            <Row>
                                <Col>
                                    <div className="panel-group" id="accordion-Edit" role="tablist" aria-multiselectable="true">
                                        <Row>
                                            <Col sm="1">
                                                <Row>
                                                    <Col style={{ margin: "auto", width: "50%", padding: "10px" }}>
                                                        <Badge className="badgeOutline" style={{ fontSize: "20px", background: "#1A959E" }} pill color="success">{1}</Badge>
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col sm="11">
                                                <Row>
                                                    <Col sm="9">
                                                        <label className="outlineLabel form-label" htmlFor="farmaddress">
                                                            Farm Address
                                                        </label>
                                                    </Col>
                                                    <Col sm="3">

                                                        {/*{outline.farmAddress != null && outline.farmAddress != "" ?*/}
                                                        {/*    <Button style={{ float: "right", marginLeft: "auto", marginRight: "-5px" }} color="success" size="sm" onClick={findMyFarm}>Find My Farm</Button> :*/}
                                                        {/*    <Button style={{ float: "right", marginLeft: "auto", marginRight: "-5px" }} color="warning" size="sm" onClick={findMyFarm}>Find My Farm</Button>*/}
                                                        {/*}*/}
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col sm="9">
                                                        <label className="largelandareaStyle">
                                                            {outline.farmAddress != null && outline.farmAddress != "" ? outline.farmAddress : "There is no address available."}
                                                        </label>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                        <hr />
                                        <Row>
                                            <Col sm="1">
                                                <Row>
                                                    <Col style={{ margin: "auto", width: "50%", padding: "10px" }}>
                                                        <Badge className="badgeOutline" style={{ fontSize: "20px", background: "#1A959E" }} pill color="success">{2}</Badge>
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col sm="11">
                                                <Row>
                                                    <Col sm="9">
                                                        <label className="outlineLabel para-light-sm ">Click Icon then Map to add</label>
                                                    </Col>
                                                    <Col sm="3">

                                                        {/*<Button className="btnClearSelection " style={{ float: "right", marginLeft: "auto", marginRight: "-5px" }} color="warning" size="sm" onClick={handleClearSelection}>*/}
                                                        {/*    Clear Selection*/}
                                                        {/*</Button>*/}
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col sm="9">
                                                        <Row>
                                                            {outline.itemTypes.map(type =>
                                                                <Col sm="4" key={uuid()}>
                                                                    <Row>
                                                                        <Col sm="12">
                                                                            {type.markerType == "marker" ?
                                                                                <>
                                                                                    <img
                                                                                        className="featureIconNew"
                                                                                        src="/images/Icons/fwfp-icon-area_centre.png"
                                                                                        onClick={(event) => handleItemClick(event, type.id, type.markerType)}
                                                                                    />{'  '}<label className="itemTypeStyle"> {type.name}</label></>
                                                                                : type.markerType == "polyline" ?
                                                                                    <><img
                                                                                        className="featureIcon"
                                                                                        src="/images/polyline.png"
                                                                                        onClick={(event) => handleItemClick(event, type.id, type.markerType)}
                                                                                    />{'  '}<label className="itemTypeStyle"> {type.name}</label></>
                                                                                    :
                                                                                    <><img
                                                                                        className="featureIconNew"
                                                                                        src="/images/Icons/fwfp-icon-boundaries.png"
                                                                                        onClick={(event) => handleItemClick(event, type.id, type.markerType)}
                                                                                    />{'  '}<label className="itemTypeStyle"> {type.name}</label></>
                                                                            }
                                                                        </Col>
                                                                    </Row>
                                                                </Col>

                                                            )}
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                        <hr />
                                        <Row>
                                            <Col sm="1">
                                                <Row>
                                                    <Col style={{ margin: "auto", width: "50%", padding: "10px" }}>
                                                        <Badge className="badgeOutline" style={{ fontSize: "20px", background: "#1A959E" }} pill color="success">{3}</Badge>
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col sm="11">
                                                <Row>
                                                    <Col sm="2">
                                                        <label className="outlineLabel form-label" htmlFor="isLargeEnterprise">
                                                            Large FARM
                                                        </label>
                                                    </Col>
                                                    <Col sm="6">
                                                        <input className="islargeEnterprise form-check-input" id="isLargeEnterprise" value={isLargeEnterprise} checked={isLargeEnterprise} type="checkbox" onChange={handlelargeEnterpriseChange} />
                                                        {' '}
                                                        <label className="outlineLabel form-label" htmlFor="isLargeEnterprise">
                                                            Large Enterprise
                                                        </label>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col sm="2">
                                                    </Col>
                                                    <Col sm="10">
                                                        <label className="largelandareaStyle">
                                                            Select If your farm is has a large land area, multi enterprise, or has land parcels some distance apart.
                                                        </label>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                        {/*<hr />*/}
                                        {/*<Row>*/}
                                        {/*    <Col sm="1">*/}
                                        {/*        <Row>*/}
                                        {/*            <Col style={{ margin: "auto", width: "50%", padding: "10px" }}>*/}
                                        {/*                <Badge className="badgeOutline" style={{ fontSize: "20px", background: "#1A959E" }} pill color="success">{4}</Badge>*/}
                                        {/*            </Col>*/}
                                        {/*        </Row>*/}
                                        {/*    </Col>*/}
                                        {/*    <Col sm="11">*/}
                                        {/*        <Row>*/}
                                        {/*            <Col sm="2">*/}
                                        {/*                <label className="form-label">Zoom Level</label>*/}
                                        {/*            </Col>*/}
                                        {/*            <Col sm="8">*/}
                                        {/*                <Row className="farmoutline-div-style">*/}
                                        {/*                    <Col>*/}
                                        {/*                        <select style={{ width: "80%" }} className="form-control input-sm map-popup-input-text" value={mapDetails.zoomLevel} onChange={handleZoomChange}>*/}
                                        {/*                            {outline.zoomLevelList.map(zoomlist =>*/}
                                        {/*                                <option key={uuid()} value={zoomlist.zoomValue}>{zoomlist.zoomText}</option>*/}
                                        {/*                            )}*/}
                                        {/*                        </select>*/}
                                        {/*                    </Col>*/}
                                        {/*                </Row>*/}
                                        {/*            </Col>*/}
                                        {/*            <Col sm="2">*/}
                                        {/*                {(roleName == 'Admin' || saveRightsForNonItemFieldsAndTables == 'true') &&*/}
                                        {/*                    <>*/}
                                        {/*                        {saving ?*/}
                                        {/*                            <Button className="button-save"*/}
                                        {/*                                color="success" style={{ float: "right" }}*/}
                                        {/*                                disabled*/}
                                        {/*                            >*/}
                                        {/*                                <Spinner size="sm">*/}
                                        {/*                                    Saving...*/}
                                        {/*                                </Spinner>*/}
                                        {/*                                <span>*/}
                                        {/*                                    {' '}Saving*/}
                                        {/*                                </span>*/}
                                        {/*                            </Button>*/}
                                        {/*                            :*/}
                                        {/*                            <Button style={{ float: "right" }} className="button-save" color="success" size="sm" onClick={handleFarmDetailSave}>*/}
                                        {/*                                Save*/}
                                        {/*                            </Button>*/}
                                        {/*                        }*/}
                                        {/*                    </>}*/}
                                        {/*            </Col>*/}
                                        {/*        </Row>*/}
                                        {/*        <Row>*/}
                                        {/*            <Col sm="2">*/}
                                        {/*            </Col>*/}
                                        {/*            <Col sm="10">*/}
                                        {/*                <label className="largelandareaStyle">*/}
                                        {/*                    On the map, ensure centre pin and overall outline fit best to map then take note of the zoom level (see bottom right on the map) then set and save the zoom level of the property here.*/}
                                        {/*                </label>*/}
                                        {/*            </Col>*/}
                                        {/*        </Row>*/}
                                        {/*    </Col>*/}
                                        {/*</Row>*/}
                                    </div>
                                </Col>
                            </Row>
                        </CardBody>
                    </Collapse>
                </Card>
                <br />
                <MapImport importShapeFilesClick={importShapeFilesClick} />
            </Col>
        </Row>
    );
}
export default OutlineMapView